<template>
    <div class="distance-settings">
        <el-popover
                placement="bottom-start"
                width="350"
                title="Infos entlang der Route"
                :visible-arrow="false"
                popper-class="smr-popper smr-popper--full-line-header"
                trigger="click"
                v-model="popperOpen"
                @show="popperShowHandler"
                @hide="popperHideHandler"
            >
                <div class="smr-popper__close smr-popper__close--show-always smr-popper__close--light" @click="popperCloseClickHandler">
                    <Icon>
                        <IconClose />
                    </Icon>
                </div>
                <div class="distance-settings__content" v-if="initalValueSet">
                    <div class="distance-settings__content__slider">
                        <SmrSlider
                            label="Entfernung zur Route"
                            :value="radius"
                            :options="sliderOptions"
                            :show-tooltip="false"
                            @change="radiusChangeHandler($event)"
                        />
                    </div>
                    <SmrButton class="distance-settings__content__button" :loading="loading" @click.native="saveClickHandler">Übernehmen</SmrButton>
                </div>
                <div slot="reference" class="distance-settings__trigger ui-center-vertically">
                    <SmrTooltip content="Suchradius ändern" position="bottom">
                        <div class="distance-settings__trigger__label caption">{{ activeLabel }}</div>
                    </SmrTooltip>
                    <Icon class="distance-settings__trigger__icon" :width="24" :height="24">
                        <IconChevronRight />
                    </Icon>
                </div>
        </el-popover>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getPermanentData, setPermanentData } from '@/utils/browser-storage';
import Icon from '@/components/Icon.vue';
import IconChevronRight from '@/components/icons/IconChevronRight.vue';
import IconClose from '@/components/icons/IconClose.vue'
import SmrSlider from '@/components/form/SmrSlider.vue'
import SmrButton from '@/components/SmrButton.vue'
import SmrTooltip from '@/components/SmrTooltip.vue'


export default {
    components: {
        Icon,
        IconChevronRight,
        IconClose,
        SmrSlider,
        SmrButton,
        SmrTooltip,
    },
    data() {
        return {
            popperOpen: false,
            radius: 1,
            loading: false,
            initalValueSet: false,
            sliderOptions: [
                {
                    value: 0.5,
                    label: 'Direkt an der Route',
                },
                {
                    value: 1,
                    label: '1km',
                },
                {
                    value: 5,
                    label: '5km',
                },
                {
                    value: 10,
                    label: '10km',
                },
                {
                    value: 15,
                    label: '15km',
                },
                {
                    value: 20,
                    label: '20km',
                },
                {
                    value: 1000,
                    label: 'Alle anzeigen',
                },
            ]
        }
    },
    computed: {
        ...mapGetters(['mobile', 'routeCorridorRadius']),
        activeLabel() {
            const activeOption = this.sliderOptions.find(option => option.value === this.routeCorridorRadius)
            return activeOption.label
        }
    },
    created() {
        this.retrieveSettingsFromBrowserStorage();
        this.radius = this.routeCorridorRadius
        this.initalValueSet = true
    }, 
    methods: {
        radiusChangeHandler(e) {
            this.radius = e
        },
        popperShowHandler() {
            if(this.mobile) {
                this.$store.commit('setDim', true)
            }
        },
        popperHideHandler() {
            if(this.mobile) {
                this.$store.commit('setDim', false)
            }
        },
        popperCloseClickHandler() {
            this.popperOpen = false;
        },
        saveClickHandler() {
            this.loading = true
            this.$store.commit('setRouteCorridorRadius', this.radius);
            setPermanentData('route-corridor-radius', this.radius);

            this.loading = false
            this.$store.dispatch('loadPOIResults');
            this.popperOpen = false
        },
        retrieveSettingsFromBrowserStorage() {
            const storedRadius = getPermanentData('route-corridor-radius');
            if(storedRadius) {
                this.$store.commit('setRouteCorridorRadius', storedRadius);
            }
        }
    }
};
</script>

<style lang="scss">
.distance-settings {
    $block: &;

   &__trigger {
       cursor: pointer;

        &__label {
            font-weight: $font-weight-medium;
            margin-right: 2px;
            text-align: right;
            white-space: nowrap;
        }

        &__icon {
            color: $color-grey-dark;
        }
   }

   &__content {
       padding: 20px 0 16px;

       &__slider {
           margin-bottom: 24px;
       }
   }
}
</style>